import { Flag, HowToRegOutlined, PersonOffOutlined } from "@mui/icons-material";
import SummaryWidget from "../../widgets/SummaryWidget";
import FlxGrid from "../../../_src_shared/components/layout/FlxGrid";
import { formatDateTime } from "../../../_src_shared/utils/functions/formatDateTime";

// const BorrowerSidebarOverviewWidgets = ({ borrower, sx }) => {
//   const getOpenRequirementsCount = (borrowerPipeline = []) => {
//     return borrowerPipeline.reduce((total, loan) => {
//       const openReqs = (loan.underwritingRequirements || []).filter(
//         (req) => req.status !== "Accepted",
//       );
//       return total + openReqs.length;
//     }, 0);
//   };
//   return (
//     <>
//       <FlxGrid width="220px" gap={2} sx={sx}>
//         <SummaryWidget
//           icon={DescriptionOutlined}
//           label="Associated Entities"
//           count={size(borrower?.associatedEntities)}
//           description="Associated with borrower"
//           {...SUMMARY_WIDGET_THEMES.gray}
//         />
//         <SummaryWidget
//           icon={DescriptionOutlined}
//           label="Experience Records"
//           count={size(borrower?.validatedExperience)}
//           description="Borrower property experience"
//           {...SUMMARY_WIDGET_THEMES.gray}
//         />

//         <SummaryWidget
//           icon={FolderOutlined}
//           label="Profile Documents"
//           count={size(borrower?.borrowerDocuments)}
//           description="Uploaded to borrower profile"
//           {...SUMMARY_WIDGET_THEMES.gray}
//         />
//       </FlxGrid>
//     </>
//   );
// };

const LoanBorrowerSidebarSummaryWidgets = ({ borrower, sx }) => {
  return (
    <>
      <FlxGrid
        width="220px"
        // width="220px"
        gap={2}
        sx={sx}
      >
        {/* <SummaryWidget
          checkable
          // checked={hasLoanAssigned}
          label="Loan Application"
          description={
            borrower?.loanApplicationSubmitted
              ? `Submitted by borrower`
              : "Not yet submitted by borrower"
          }
        /> */}
        <SummaryWidget
          checkable
          checked={borrower?.isGuarantor}
          label="Guarantor"
          checkedIcon={<HowToRegOutlined />}
          uncheckedIcon={<PersonOffOutlined />}
          checkedColor="purple"
          uncheckedColor={"gray"}
          description={
            borrower?.isGuarantor
              ? `Is a guarantor on this loan`
              : "Not a guarantor"
          }
        />
        <SummaryWidget
          checkable
          checked={borrower?.borrowerPortalUserId}
          label="Linked Portal User"
          description={
            borrower?.borrowerPortalUserId
              ? `Last synced: ${formatDateTime(borrower?.lastSyncedFromPortal)}`
              : "Not linked to portal user"
          }
        />

        <SummaryWidget
          checkable
          checked={borrower?.creditReportDate}
          label="Credit Report"
          checkedColor="green"
          uncheckedColor={"gray"}
          description={
            borrower?.creditReportDate
              ? `Entered: ${formatDateTime(borrower?.creditReportDate)}`
              : "No credit report available"
          }
        />
        <SummaryWidget
          checkable
          checked={borrower?.backgroundDate}
          label="Background Check"
          checkedColor="green"
          uncheckedColor={"gray"}
          description={
            borrower?.backgroundDate
              ? `Entered: ${formatDateTime(borrower?.backgroundDate)}`
              : "No background check available"
          }
        />
        <SummaryWidget
          checkable
          checked={borrower?.creditAuthDate}
          label="Credit Authorization"
          checkedColor="green"
          uncheckedColor={"gray"}
          description={
            borrower?.creditAuthDate
              ? `Entered: ${formatDateTime(borrower?.creditAuthDate)}`
              : "No credit authorization available"
          }
        />
        <SummaryWidget
          checkable
          checked={borrower?.repeatBorrowerFlag}
          label="Repeat Borrower"
          // checkedIcon={<Flag />}
          checkedColor="green"
          uncheckedColor={"gray"}
          description={
            borrower?.repeatBorrowerFlag
              ? `Is a repeat borrower`
              : "Not a repeat borrower"
          }
        />
        <SummaryWidget
          checkable
          checked={borrower?.firstTimeHomebuyer}
          label="First-Time Homebuyer"
          // checkedIcon={<Flag />}
          checkedColor="green"
          uncheckedColor={"gray"}
          description={
            borrower?.firstTimeHomebuyer
              ? `Is a first-time homebuyer`
              : "Not a first-time homebuyer"
          }
        />
        <SummaryWidget
          checkable
          checked={borrower?.foreignNationalFlag}
          label="Foreign National"
          checkedIcon={<Flag />}
          checkedColor="amber"
          uncheckedColor={"gray"}
          description={
            borrower?.foreignNationalFlag
              ? `Is a foreign national`
              : "Not a foreign national"
          }
        />

        {/* <SummaryWidget
          icon={DescriptionOutlined}
          label="Associated Documents"
          // label="Active Loans"
          count={size(borrower?.associations?.loanDocuments) || 0}
          description="Loan documents associated with this borrower"
          // description="Tied to this borrower"
          {...SUMMARY_WIDGET_THEMES.blue}
        /> */}
        {borrower?.bankruptcy_flag && (
          <SummaryWidget
            checkable
            checked={borrower?.bankruptcy_flag}
            label="Bankruptcy Flag"
            checkedIcon={<Flag />}
            checkedColor="amber"
            uncheckedColor={"gray"}
            description={
              borrower?.bankruptcy_flag
                ? `Has declared bankruptcy`
                : "No bankruptcy history"
            }
          />
        )}
        {/* <SummaryWidget
          icon={AssignmentOutlined}
          label="Example Widget"
          // label="Staged Loan Apps"
          count={size(borrower?.stagedApplications)}
          description={
            size(borrower?.stagedApplications) > 0
              ? `Staged for the borrower`
              : "No apps created"
          }
          {...SUMMARY_WIDGET_THEMES.amber}
        />
        <SummaryWidget
          icon={DescriptionOutlined}
          label="Example Widget"
          // label="Active Loans"
          count={size(borrower?.borrowerPipeline)}
          description="Visible to the borrower"
          // description="Tied to this borrower"
          {...SUMMARY_WIDGET_THEMES.blue}
        />
        <SummaryWidget
          icon={GavelOutlined}
          label="Example Widget"
          // label="Pending Term Sheets"
          count={size(borrower?.pendingTermSheets)}
          description={"Awaiting borrower approval"}
          {...SUMMARY_WIDGET_THEMES.coral}
        />
        <SummaryWidget
          icon={GavelOutlined}
          label="Example Widget"
          // label="Accepted Term Sheets"
          count={size(borrower?.acceptedTermSheets)}
          description={"Accepted by the borrower"}
          {...SUMMARY_WIDGET_THEMES.teal}
        />
        <SummaryWidget
          icon={DescriptionOutlined}
          label="Example Widget"
          // label="Total Open Conditions"
          count={getOpenRequirementsCount(borrower?.borrowerPipeline)}
          description="Across all borrower loans"
          {...SUMMARY_WIDGET_THEMES.purple}
        /> */}
      </FlxGrid>
    </>
  );
};
export default LoanBorrowerSidebarSummaryWidgets;
